export class NICECountry {

    countryId: number;
    countryCode: string;
    countryName: string;

    constructor(country?) {
        this.countryId = country.countryId || '';
        this.countryCode = country.countryCode || 'US';
        this.countryName = country.countryName  || 'United States';
    }
}
